(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertySearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});


	form.load = function load($form)
	{
		$('.ai-form-field').change(function getCount() {
			var url          = '/AllInclusiveProperties/countResults',
				$form        = $('#all_inclusive_search'),
				record_count = 0;

			Adzuki.Ajax.post(url, $form.serialize()).then(
				function success(response) {
					record_count = parseInt(response.count);

					if (record_count && record_count > 0) {
						$('.aip-num-results').html(record_count + (record_count === 1 ? ' property' : ' properties'));
					} else {
						$('.aip-num-results').html('No matching properties');
					}
				}
			);
		});

		$('#allinclusivepropertysearch-include_live_pricing').change(function toggleLivePricing() {
			$form.find('.live-pricing-fields').toggleClass('hidden', !this.checked);
		});


		$('#allinclusivepropertysearch-num_children').change(function showChildAges()
		{
			var $fields = $form.find('.child-age');

			$fields
				.addClass('hidden')
				.find('select')
				.prop('disabled', true);

			if (this.value > 0) {
				$fields.slice(0, this.value)
					.removeClass('hidden')
					.find('select')
					.prop('disabled', false);
			}
		});
	};
}(jQuery, window.Adzuki || {}));